/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { provinciaActivosGet } from '../fn/province/provincia-activos-get';
import { ProvinciaActivosGet$Params } from '../fn/province/provincia-activos-get';
import { provinciaDepartamentoIdDepartamentGet } from '../fn/province/provincia-departamento-id-departament-get';
import { ProvinciaDepartamentoIdDepartamentGet$Params } from '../fn/province/provincia-departamento-id-departament-get';
import { provinciaGet } from '../fn/province/provincia-get';
import { ProvinciaGet$Params } from '../fn/province/provincia-get';
import { provinciaIdProvinceGet } from '../fn/province/provincia-id-province-get';
import { ProvinciaIdProvinceGet$Params } from '../fn/province/provincia-id-province-get';

@Injectable({ providedIn: 'root' })
export class ProvinceService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `provinciaGet()` */
  static readonly ProvinciaGetPath = '/provincia';

  /**
   * getAll.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `provinciaGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  provinciaGet$Response(params?: ProvinciaGet$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
    return provinciaGet(this.http, this.rootUrl, params, context);
  }

  /**
   * getAll.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `provinciaGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  provinciaGet(params?: ProvinciaGet$Params, context?: HttpContext): Observable<any> {
    return this.provinciaGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

  /** Path part for operation `provinciaActivosGet()` */
  static readonly ProvinciaActivosGetPath = '/provincia/activos';

  /**
   * getAllActive.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `provinciaActivosGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  provinciaActivosGet$Response(params?: ProvinciaActivosGet$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
    return provinciaActivosGet(this.http, this.rootUrl, params, context);
  }

  /**
   * getAllActive.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `provinciaActivosGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  provinciaActivosGet(params?: ProvinciaActivosGet$Params, context?: HttpContext): Observable<any> {
    return this.provinciaActivosGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

  /** Path part for operation `provinciaIdProvinceGet()` */
  static readonly ProvinciaIdProvinceGetPath = '/provincia/idProvince';

  /**
   * getById.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `provinciaIdProvinceGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  provinciaIdProvinceGet$Response(params?: ProvinciaIdProvinceGet$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
    return provinciaIdProvinceGet(this.http, this.rootUrl, params, context);
  }

  /**
   * getById.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `provinciaIdProvinceGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  provinciaIdProvinceGet(params?: ProvinciaIdProvinceGet$Params, context?: HttpContext): Observable<any> {
    return this.provinciaIdProvinceGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

  /** Path part for operation `provinciaDepartamentoIdDepartamentGet()` */
  static readonly ProvinciaDepartamentoIdDepartamentGetPath = '/provincia/departamento/idDepartament';

  /**
   * getByProvince.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `provinciaDepartamentoIdDepartamentGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  provinciaDepartamentoIdDepartamentGet$Response(params?: ProvinciaDepartamentoIdDepartamentGet$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
    return provinciaDepartamentoIdDepartamentGet(this.http, this.rootUrl, params, context);
  }

  /**
   * getByProvince.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `provinciaDepartamentoIdDepartamentGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  provinciaDepartamentoIdDepartamentGet(params?: ProvinciaDepartamentoIdDepartamentGet$Params, context?: HttpContext): Observable<any> {
    return this.provinciaDepartamentoIdDepartamentGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

}
